import React, { useEffect } from 'react';
import '../../styles/legal.css';

const Terms: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        
        <div className="legal-header">
          <h1 className="legal-title">Terms and Conditions</h1>
          <p className="legal-subtitle">Last updated: May 10, 2026</p>
        </div>

        <div className="legal-content">
          <p>Welcome to Industrybull. These terms and conditions outline the rules and regulations for the use of Industrybull's Website, located at www.industrybull.com.</p>
          <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use Industrybull if you do not agree to take all of the terms and conditions stated on this page.</p>
          
          <h2>1. Introduction</h2>
          <p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company, Industrybull. "Party", "Parties", or "Us", refers to both the Client and ourselves.</p>

          <h2>2. Use of the Site</h2>
          <p>You agree to use the Site only for lawful purposes. You are prohibited from any use of the Site that would constitute an illegal offense, give rise to liability or otherwise violate any applicable local, state, national or international law or regulation.</p>
          <ul>
            <li>You must not republish material from Industrybull.</li>
            <li>You must not sell, rent or sub-license material from Industrybull.</li>
            <li>You must not reproduce, duplicate or copy material from Industrybull.</li>
            <li>You must not redistribute content from Industrybull.</li>
          </ul>

          <h2>3. User Accounts</h2>
          <p>As a user of this website, you may be asked to register with us and provide private information. You are responsible for ensuring the accuracy of this information, and you are responsible for maintaining the safety and security of your identifying information.</p>
          <p>If you think there are any possible issues regarding the security of your account on the website, inform us immediately so we may address it accordingly.</p>

          <h2>4. Pricing and Availability</h2>
          <p>We list availability information for products sold by us on the website. As we process your order, we will inform you by e-mail as soon as possible if any products you order turn out to be unavailable. Prices are subject to change without notice.</p>
          <p>While we try and ensure that all details, descriptions and prices which appear on this Website are accurate, errors may occur. If we discover an error in the price of any goods which you have ordered we will inform you of this as soon as possible and give you the option of reconfirming your order at the correct price or cancelling it.</p>

          <h2>5. Payment Terms</h2>
          <p>We accept payment via various methods including credit cards, debit cards, net banking, and Cash on Delivery (where applicable). By submitting an order, you represent and warrant that you are authorized to use the designated payment method and authorize us to charge your order to that card or other payment method.</p>

          <h2>6. Limitation of Liability</h2>
          <p>In no event shall Industrybull, nor any of its officers, directors and employees, be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract. Industrybull, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.</p>

          <h2>7. Indemnification</h2>
          <p>You hereby indemnify to the fullest extent Industrybull from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.</p>

          <h2>8. Modifications</h2>
          <p>Industrybull is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.</p>

          <h2>9. Governing Law</h2>
          <p>These Terms will be governed by and interpreted in accordance with the laws of the State/Country in which Industrybull is headquartered, and you submit to the non-exclusive jurisdiction of the state and federal courts located in for the resolution of any disputes.</p>
        </div>

      </div>
    </div>
  );
};

export default Terms;
